<div layout layout-space-between margin-bottom>
  <rt-heading>{{ 'tlc.current_user.companies.heading' | translate }}</rt-heading>
  @if (canAddNewCompany()) {
    <rt-button variant="outline" (click)="onAddOrg()">
      <rt-icon name="add" />
      <span>{{ 'tlc.current_user.companies.button' | translate }}</span>
    </rt-button>
  }
</div>

<div layout layout-vertical>
  @for (member of members(); track member.org.guid; let last = $last) {
    <tlc-current-user-profile-companies-item
      [signedIn]="currenMembershipOrgGuid() === member.org.guid"
      [isOwner]="member.owner"
      [companyName]="member.org.name"
      (leaveCompany)="leaveCompany(member.org.guid, member.owner)"
      (signIn)="signIn(member.org.guid)"
      [attr.margin-bottom-small]="!last || null"
    />
  }
</div>
